import InfiniteHits from './InfiniteHits'

export default InfiniteHits
